import React from 'react';

import {
  BoldText,
  ClauseText,
  DangerText,
  InfoText,
} from './Components/ContractText';
import { CONTRACT_DEADLINES } from './contractDeadlines';

interface Props {
  buyerName?: string;
  contract?: any;
}

const NoticeAssesment = ({ buyerName, contract }: Props) => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Notices, Assessments, and Municipal Requirements
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside text-bold">
        <li>
          In the event any notices of public and/or private assessments are
          received after Seller has signed this Agreement and before settlement,
          Seller will within {CONTRACT_DEADLINES.noticeResponseDays} days of
          receiving the notices and/or assessments provide a copy of the notices
          and/or assessments to Buyer and will notify Buyer in writing that
          Seller will:
          <ol className="text-black mb-2 text-base list-decimal list-inside text-bold">
            <li>
              Fully comply with the notices and/or assessments, at Seller’s
              expense, before settlement. If Seller fully complies with the
              notices and/or assessments, Buyer accepts the Property and agrees
              to the Release clause of this Agreement.
            </li>
            <li>
              Not comply with the notices and/or assessments. If Seller chooses
              not to comply with the notices and/or assessments, or fails within
              the stated time to notify Buyer whether Seller will comply, Buyer
              will notify Seller in writing within{' '}
              {CONTRACT_DEADLINES.noticeResponseDays} days that Buyer will:
              <ol className="ml-4 text-black mb-2 text-base list-decimal list-inside text-bold">
                <li>
                  Comply with the notices and/or assessments at Buyer’s expense,
                  accept the Property, and agree to the Release clause of this
                  Agreement, OR
                </li>
                <li>
                  Terminate this Agreement by written notice to Seller, with all
                  deposit money returned to Buyer according to the terms of this
                  Agreement.
                </li>
              </ol>
            </li>
            <li>
              If Buyer fails to respond within{' '}
              {CONTRACT_DEADLINES.noticeResponseDays} days or fails to terminate
              this Agreement by written notice to Seller within that time, Buyer
              will accept the Property and agree to the Release clause of this
              Agreement.{' '}
            </li>
          </ol>
        </li>
        <li>
          If required by law, within {CONTRACT_DEADLINES.municipalCertOrderDays}{' '}
          days from the Execution Date of this Agreement, but in no case later
          than {CONTRACT_DEADLINES.municipalCertDaysBeforeSettlement} days prior
          to Settlement Date, Seller will order at Seller’s expense a
          certification from the appropriate municipal department(s) disclosing
          notice of any uncorrected violations of zoning, housing, building,
          safety or fire ordinances and/or a certificate permitting occupancy of
          the Property. If Buyer receives a notice of any required
          repairs/improvements, Buyer will promptly deliver a copy of the notice
          to Seller.
        </li>
        <li>
          Within {CONTRACT_DEADLINES.noticeResponseDays} days of receiving
          notice from the municipality that repairs/improvements are required,
          Seller will deliver a copy of the notice to Buyer and notify Buyer in
          writing that Seller will:
          <ol className="ml-4 text-black mb-2 text-base list-decimal list-inside text-bold">
            <li>
              Make the required repairs/improvements to the satisfaction of the
              municipality. If Seller makes the required repairs/improvements,
              Buyer accepts the Property and agrees to the Release clause of
              this Agreement
            </li>
            <li>
              Not make the required repairs/improvements. If Seller chooses not
              to make the required repairs/improvements, Buyer will notify
              Seller in writing within{' '}
              <ClauseText>{CONTRACT_DEADLINES.noticeResponseDays}</ClauseText>{' '}
              days that Buyer will:
              <ol className="ml-4 text-black mb-2 text-base list-decimal list-inside text-bold">
                <li>
                  Accept a temporary access certificate or temporary use and
                  occupancy certificate, agree to the Release clause of this
                  Agreement and make the repairs at Buyer’s expense after
                  settlement
                </li>
                <li>
                  Terminate this Agreement by written notice to Seller with all
                  deposit money returned to Buyer according to the terms of this
                  Agreement.
                </li>
              </ol>
            </li>
            <li>
              If Buyer fails to respond within{' '}
              {CONTRACT_DEADLINES.noticeResponseDays} days or fails to terminate
              this Agreement by written notice to Seller within that time, Buyer
              will accept the Property and agree to the Release clause of this
              Agreement, and Buyer accepts the responsibility to perform the
              repairs/improvements according to the terms of the notice provided
              by the municipality.
            </li>
          </ol>
        </li>
        <li>
          If repairs/improvements are required and Seller fails to provide a
          copy of the notice to Buyer as required in this paragraph, Seller will
          perform all repairs/improvements as required by the notice at Seller’s
          expense. This clause will survive settlement.
        </li>
      </ol>
    </div>
  );
};

export default NoticeAssesment;
